<template>
  <div class="comp-tab-title bb-3">
    <span class="text-primary">{{title}}</span>
  </div>
</template>

<script>
  /**
   * @author yueheqin
   * @date 2019/1/5
   * @project kaoshizhongxin-pc
   * @desc
   */
  export default {
    name: 'comp-tab-title',
    props: {
      title: {
        type: String,
        default: '标题名称'
      }
    },
    data () {
      return {}
    }
  }
</script>

<style lang="less">
  @import "../styles/_mixins-wln";
  .comp-tab-title {
    span{
      display: inline-block;
      height: 40px;
      line-height: 40px;
      border-bottom: 2px solid @primary;
    }
  }
</style>
